import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import { Platform } from 'react-native';

export function getInitialDoman(): string {
  let result = getLogicalHost();
  if (!AppUtilities.isWeb()) {
    const savedDomain = AppUtilities.getLocalDataDomain() as string | null;
    if (savedDomain && savedDomain.length > 0) {
      result = savedDomain;
    }
  }
  return result;
}

export function getInitialIsMainLogicalHost(): boolean {
  return getInitialDoman() == AppConstants.HOST;
}

export function hasAccessToken() : boolean {
  return AppUtilities.hasAccessToken() as boolean;
}

export function isLoggedIn() : boolean {
  let loggedIn = hasAccessToken();
  if (!loggedIn) {
    if (Platform.OS === 'web') {
      if (typeof document !== 'undefined' && document && document.cookie) {
        const keyValuePairs = document.cookie.split(/; */);
        for(var i = 0; i < keyValuePairs.length; i++) {
          const name = keyValuePairs[i].substring(0, keyValuePairs[i].indexOf('='));
          const value = keyValuePairs[i].substring(keyValuePairs[i].indexOf('=')+1);
          if (name == "loggedin") {
            loggedIn = true;
          }
        }
      }
    }
  }
  return loggedIn;
}

/**
 * Gets the logical host of the current context, i.e. either
 * the main host (i.e. rabbl.com) or a
 * community host without the rabbl.com suffix (e.g. somecommunity).
 * This will never have a port number. In other words, even
 * when developing locally on localhost, this will still
 * return rabbl.com|somecommunity. There is no ending /.
 * 
 * @param [keepFullHostForSubdomains=false] If true, keep the full host
 * for subdomains; for example, return somecommunity.rabbl.com
 * instead of somecommunity.
 */
export function getLogicalHost(keepFullHostForSubdomains: boolean = false) : string {
  return AppUtilities.getLogicalHost(keepFullHostForSubdomains);
}

export function getDefaultIsAgePassed(): boolean {
  let defaultIsAgePassed = false;
  const isAgePassedStored = AppUtilities.getStoredValue("isAgePassed");
  if (isAgePassedStored && (isAgePassedStored as any).val === true) {
    defaultIsAgePassed = true;
  }
  if (isLoggedIn()) {
    defaultIsAgePassed = true;
  }
  return defaultIsAgePassed;
}

export function getEnumValuesJoined<T extends object>(bits: number | undefined, enumList: T, enumNames: Map<number, string>, join: string = ", ") : string {
  let result = "";
  if (bits) {
    for (const keyName of Object.keys(enumList)) {
      const keyAsNumber = Number(keyName);
      if (!isNaN(keyAsNumber)) {
        if ((bits & keyAsNumber) != 0) {
          if (result.length > 0) {
            result += join;
          }
          result += enumNames.get(keyAsNumber);
        }
      }
    }
  }
  if (result.length == 0) {
    result = "Not set";
  }
  return result;
}
